import React, { useEffect, useState } from 'react';
import preview from '../documents/GST.png';
import successIcon from '../documents/success.svg';
import { getUploadedDocumentsForSummary } from 'home/view/manage-feasibility/services';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';

function KdmImage({ order }) {
  const [uploadedDoc, setUploadedDoc] = useState({});
  const [kdmImageUrl, setKdmImageUrl] = useState(null);
  const [previewClicked, setPreviewClicked] = useState(false);
  const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  const getDocuments = async (keyName) => {
    const payload = { documentType: 'AUTHORIZED_SIGNATORY', documentName: keyName };

    try {
      const { res, err } = await getUploadedDocumentsForSummary(payload, summaryAuthToken);

      if (res) {
        console.log(res, 'images fetched');
        const { data } = res;
        const type = 'image/jpeg';

        const file = new Blob([data], { type });

        var fileURL = URL.createObjectURL(file);
        setKdmImageUrl(fileURL);

        // const { data } = res;
        // const file = new Blob([data], { type });

        // var fileURL = URL.createObjectURL(file);
        // window.open(fileURL, '_blank');
        // res.arrayBuffer().then();
        // objImg.img = new Buffer.from(bitMap).toString('base64');
        // setPreviewImage('data:image/png;base64,' + result.img);
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setError({
          state: true,
          message: errorMsg || 'Error while opening files'
        });

        setToast(true, errorMsg, ERROR_TOAST);

        throw new Error(errorMsg);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onPreviewClick = () => {
    console.log('preview clicked');
    window.open(kdmImageUrl, '_blank');
  };

  useEffect(() => {
    getDocuments('KDM');
  }, []);

  return (
    <>
      {uploadedDoc ? (
        <div className="kdm-img">
          <p>
            <img src={kdmImageUrl} alt="Preview Image" />
          </p>
          <p className="links" onClick={onPreviewClick}>
            Preview
          </p>
        </div>
      ) : (
        ''
      )}
    </>
  );
}

export default KdmImage;
